<template>
  <div class="stepper__container">
    <div
      v-for="(step, index) in steps"
      :key="index"
      :class="`stepper__item ${step.active ? 'active' : ''}`"
      :data-testid="`stepper-item-${index}`"
      :aria-current="!!step.active"
    >
      <span class="stepper__item-bar" />
      <div class="stepper__item-description">
        <BaseText v-if="step.title" size="md" class="stepper__item-title">
          {{ step.title }}
        </BaseText>
        <BaseText
          v-if="step.description"
          size="sm"
          :color="NebraskaColors.textSecondary"
        >
          {{ step.description }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText } from '@warrenbrasil/nebraska-web';
import { IStep } from './stepper-types';

@Component({
  components: { BaseText }
})
export default class Stepper extends Vue {
  public readonly NebraskaColors = NebraskaColors;
  @Prop({ type: Array, required: true })
  public readonly steps!: IStep[];
}
</script>
<style lang="less" scoped>
.stepper {
  &__container {
    display: grid;
    justify-content: space-between;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: @size-spacing-x300;
    margin-top: @size-spacing-x400;
  }
  &__item-bar {
    display: flex;
    height: 4px;
    background-color: @brand-secondary-darken;
    border-radius: @size-radius-x100;
  }
  &__item-description {
    text-align: center;
    margin-top: @size-spacing-x400;
  }
  &__item {
    &.active {
      .stepper__item-bar {
        background-color: @brand-primary-darken;
      }
      .stepper__item-title {
        font-weight: bold;
      }
    }
    &:first-child {
      .stepper__item-description {
        text-align: left;
      }
    }
    &:last-child {
      .stepper__item-description {
        text-align: right;
      }
    }
  }
}
</style>
